export class TableContextSegmentColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "explains",
            "baseName": "explains",
            "type": "number",
            "format": ""
        },
        {
            "name": "segments",
            "baseName": "segments",
            "type": "number",
            "format": ""
        },
        {
            "name": "topShare",
            "baseName": "topShare",
            "type": "number",
            "format": ""
        },
        {
            "name": "decision",
            "baseName": "decision",
            "type": "TableContextSegmentColumnDecision",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSegmentColumn.attributeTypeMap;
    }
    constructor() {
    }
}
